export const Experiments = Object.freeze({
  WatchPageStats: 'watch_page_stats'
})
